<template>
  <div class="repeatbox" :class="isdisabled ? 'disabled' : ''">
    <div v-if="value !== -1" class="repeat-wrap" @click="onClickRepeatWrap">
      <span class="inpubox">{{ value }}시간 마다</span>

      <img
        class="arrow-icon"
        :class="isOpenSelectList ? 'active' : ''"
        src="/media/images/icon/arrow-up-lg-icon.png"
        alt="selectboxarrow-down-icon.png"
      />
    </div>
    <!-- null일때 -->
    <div v-else class="repeat-wrap" @click="!isdisabled ? (isOpenSelectList = !isOpenSelectList) : () => {}">
      <span class="inpubox null"> 선택해주세요</span>
      <img
        class="arrow-icon"
        :class="isOpenSelectList ? 'active' : ''"
        src="/media/images/icon/arrow-up-lg-icon.png"
        alt="selectboxarrow-down-icon.png"
      />
    </div>

    <ul v-click-outside="outSideClick" class="select-repeatlist-wrap" v-if="isOpenSelectList">
      <li class="select-repeat-item" v-for="item in selectlist" :key="item.key" @click="onClickItem(item)">
        {{ item.value }}시간

        <img
          class="check-icon"
          v-if="value === item.key"
          src="/media/images/icon/check-black-lg-icon.png"
          alt="checed-black-lg-icon.png"
        />
      </li>
    </ul>
  </div>
</template>
<script>
import vClickOutside from 'v-click-outside';
export default {
  props: {
    value: {
      type: Number,
      default: null,
      required: false
    },
    isdisabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  emits: ['click-item'],
  data() {
    return {
      selectlist: [
        { key: 1, value: 1 },
        { key: 2, value: 2 },
        { key: 3, value: 3 },
        { key: 6, value: 6 },
        { key: 12, value: 12 }
      ],
      selectedValue: '',
      isOpenSelectList: false
    };
  },
  methods: {
    onClickRepeatWrap() {
      if (this.isdisabled) return;
      this.isOpenSelectList = !this.isOpenSelectList;
    },
    outSideClick() {
      this.isOpenSelectList = false;
    },
    onClickItem(item) {
      this.$emit('click-item', item.key);
      this.isOpenSelectList = false;
    }
  }
};
</script>
<style scoped src="@/assets/css/selectrepeatbox/selectrepeatbox.css"></style>
